export default function makeProfileGetters () {
  return {
    displayName: (state) => {
      if (!state.data) {
        return null
      }
      const last = state.data.last.display || ''
      const first = state.data.first.display || ''
      return `${first} ${last}`
    }
  }
}
